// helpers
import { getRewardsPageData } from 'shared/api/rewards-page';

export const fetchRewardsPageData = async ({
  headers,
  customerId,
}: {
  headers: Record<string, string>;
  customerId?: number;
}) => {
  try {
    // Fetch data from the API
    const rewardsPageData = await getRewardsPageData({
      params: {
        fetchRewardsOffers: true, // Add any required query params here
        customerId: customerId, // Pass customerId if available
      },
      headers,
    });

    return rewardsPageData;
  } catch (error: any) {
    console.error('Error fetching Rewards Page Data:', error);
    throw error; // Propagate the error to the caller
  }
};
